/* ============================================================================
   ENGORI Mengenstaffel — dreistufige Kaufauswahl als Akkordeon in der Buy-Box
   Markup: snippets/engori-staffel.liquid · CSS: engori-premium.css (.eng-stf)

   Loest das Bundle-Modal ab. Die Farbauswahl je Stueck ist bewusst dieselbe
   Mechanik wie dort (engori-bundle-modal.js): gleiche Datenstruktur, gleiche
   Algorithmen (cleanLabel / matchingFor / valuesFor), gleiche CSS-Klassen
   .eng-bdl__*. Das Modal-Snippet und sein JS bleiben unangetastet — sie sind
   der Rueckweg.

   Preise stehen NICHT hier. Sie kommen aus dem Liquid (product.price) und
   werden hier nur weitergereicht. Auch der Pflichthinweis ueber den Knoepfen
   wird nicht getextet, sondern aus den fertig gerenderten Liquid-Absaetzen
   umgeschaltet und gespiegelt.

   --- Express-Zahlarten, der heikle Teil ------------------------------------
   ⚠️ KORRIGIERT am 07.09.2026. Bis dahin stand hier, `{{ form | payment_button }}`
   koenne "zwei oder vier verschiedene Farben nicht aufnehmen". Das war bis zum
   27.02.2026 richtig und ist es seitdem nicht mehr:

     shopify.dev/docs/storefronts/themes/pricing-payments/accelerated-checkout/
     multiple-product-checkout (abgerufen 07.09.2026) sowie der Changelog-
     Eintrag "Accelerated checkouts now support multiple product variants on
     the product page" vom 27.02.2026.

   Das Produktformular nimmt zusaetzliche Positionen als versteckte Felder auf:

     <input type="hidden" name="shopify-additional-items[1][id]"       value="…">
     <input type="hidden" name="shopify-additional-items[1][quantity]" value="1">

   Der Index beginnt laut Doku bei 1; [quantity] ist optional und faellt auf 1
   zurueck. Die Doku nennt zwei Grenzen: es gilt nur im Online-Store, und die
   Wallet "Buy with Prime" traegt mehr als eine Variante nicht mit (fuer ENGORI
   ohne Belang — der Store liefert PayPal, Google Pay und auf iOS Apple Pay).

   Daraus folgt, was hier passiert:
   · Alle drei Stufen — die nativen Express-Knoepfe bleiben stehen, sobald die
     Auswahl vollstaendig ist. Stufe 1 kauft die eine Variante, Stufe 2 und 4
     kaufen die Hauptvariante plus die uebrigen Farben als Zusatzpositionen.
     setzeFormularPosten() traegt sie ein und raeumt sie wieder weg.
   · Nur wenn schon etwas im Warenkorb liegt, treten sie ab: sie kaufen den
     Inhalt des FORMULARS, nicht den des Warenkorbs, und wuerden das Vorhandene
     stillschweigend uebergehen. Dann uebernimmt der Warenkorb-Block
     (snippets/engori-express-korb.liquid).
   · Der eigene Knopf "Direkt zur Kasse" bleibt daneben bestehen. Er legt die
     Positionen per cart/add.js ab und geht nach /checkout — der Weg fuer alle,
     die keine Wallet nutzen. Das ist KEIN Express-Knopf und gibt auch nicht
     vor, einer zu sein.

   Was NICHT geht, gemessen am 07.09.2026 am Live-Theme 197984747864:
   Die Wallet-Knoepfe lassen sich nicht per Skript ausloesen. PayPal rendert in
   einem zoid-iframe fremder Herkunft (contentDocument ist null), Google Pay in
   einem GESCHLOSSENEN Shadow-Root — shopify.dev sagt das ausdruecklich:
   "The accelerated checkout buttons hide their HTML in a custom element with a
   closed shadow DOM." Ein "erst cart/add.js, dann Knopf klicken" scheitert also
   nicht erst am Popup-Blocker, sondern schon daran, dass es nichts zu klicken
   gibt. Deshalb wird das Formular bestueckt und nicht der Warenkorb.

   --- Farbwahl dauerhaft oben (Schalter, 26.09.2026) ------------------------
   Setzt die Vorlage im render-Aufruf `farbe_oben: true`, traegt die Section die
   Klasse .eng-stf--farbe-oben und der Varianten-Picker wird in den Halter ganz
   oben in der Staffel verschoben statt in den Klappbereich der Einzelstufe. Die
   Stufenkarten bleiben unveraendert, auch die Vorwahl.

   --- Picker oben ZIEHT die Buendel-Farbplaetze mit (29.09.2026) ------------
   ⚠️ Das ist die ausdrueckliche Ruecknahme der Trennung vom 27.09.2026. Hier
   stand bis dahin die Vorgabe „Der Variant Selector ist nur fuer 1 oder wenn
   man sich die Bilder anschauen moechte. 1+1 geschenkt hat nichts mit ihm zu
   tun." Werner hat das am 29.09.2026 geaendert, woertlich: „ich will das die
   erste vorausgewaehlt ist und dann alle anderen auswaehlbar sind und die in
   1+1 auch mit ausgewaehlt sind es sei denn die wurden eingestellt und 2+2
   auch". Wer die alte Vorgabe im Kopf hat, darf das nicht „zurueckreparieren".

   Geltender Stand:
   · Beim Seitenaufbau ist die erste Farbe oben markiert (uebernehmen() laeuft
     sofort, nicht erst nach einem Klick) und jede Buendel-Tasche traegt sie.
   · Jede andere Farbe ist oben waehlbar; die Anzeige („gewaehlt <Farbe>") folgt
     der Wahl in JEDER Stufe, auch in den Buendelstufen.
   · Ein Klick oben uebernimmt die Farbe in alle Farbplaetze der Buendelstufen
     — AUSSER in die, die der Kunde selbst eingestellt hat. Ein selbst gesetzter
     Platz traegt `slot.vomKunden = true` und behaelt seine Farbe.
   · Vorwahl bleibt die Buendelstufe (vorwahl im render-Aufruf).

   Nur EINE Richtung, deshalb kein Aufschaukeln: der Picker schreibt in die
   Farbplaetze (koppleNachUnten), die Farbplaetze schreiben NICHT in den Picker.
   koppleNachUnten() vergleicht ausserdem, bevor es setzt, und bricht ab, wenn
   nichts zu tun ist. Der Merker `data-eng-still` samt 120-ms-Fenster (26.09.)
   wird dafuer nicht gebraucht und kommt nicht zurueck.

   Die Express-Zahlarten folgen `.product-variant-id`, und das Theme schreibt
   dort bei jedem Picker-Klick die Picker-Variante hinein. setzeExpressModus()
   setzt das Feld deshalb nach jedem Picker-Wechsel neu: Stufe 1 = Picker-
   Variante, Buendel = Tasche 1 plus Zusatzpositionen.
   ========================================================================= */
(function () {
  'use strict';

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* --- Anzeigename: redundante Anteile aus dem eindeutigen Optionswert raus --
     "Königsblau / Blau – Rechts"  + ["Zweifarbig","Rechts"]  ->  "Königsblau / Blau"
     "Schwarz - Rechts"           + ["Rechts"]                ->  "Schwarz"
     Wortgleich aus engori-bundle-modal.js uebernommen.                       */
  function cleanLabel(variant, uniqIdx) {
    var label = variant.opts[uniqIdx] || '';
    variant.opts.forEach(function (val, i) {
      if (i === uniqIdx || !val) return;
      label = label.split(val).join('');
    });
    return label.replace(/[\s–—-]+$/, '').replace(/^[\s–—-]+/, '').trim() || (variant.opts[uniqIdx] || '');
  }

  /* Verstecktes Formularfeld fuer eine Zusatzposition des Express-Kaufs.
     data-eng-zusatz markiert es als unseres — setzeFormularPosten() raeumt
     ausschliesslich Felder mit dieser Marke wieder weg. */
  function feldZusatz(name, wert) {
    var el = document.createElement('input');
    el.type = 'hidden';
    el.name = name;
    el.value = String(wert);
    el.setAttribute('data-eng-zusatz', '');
    return el;
  }

  function Staffel(el, data) {
    this.el = el;
    this.data = data;
    this.uniqIdx = data.uniqPos - 1;
    this.slots = [];
    this.menge = 1;
    this.stufe = 1;
    this.erstlauf = true;

    /* null = "rechne selbst aus, welche Position dran ist".
       Eine Zahl = der Kunde hat eine Position von Hand aufgeklappt. */
    this.openSlot = null;

    this.radios      = Array.prototype.slice.call(el.querySelectorAll('.eng-stf__radio'));
    this.panels      = Array.prototype.slice.call(el.querySelectorAll('[data-eng-stf-panel]'));
    this.erstAufbau  = true;   /* siehe mobilZugeklappt weiter unten */
    this.pflichtAbs  = Array.prototype.slice.call(el.querySelectorAll('[data-eng-stf-pflicht]'));
    this.ansage      = el.querySelector('[data-eng-stf-live]');
    this.errorBox    = el.querySelector('[data-eng-stf-error]');
    this.submitBtn   = el.querySelector('[data-eng-stf-submit]');
    this.submitLbl   = el.querySelector('[data-eng-stf-cta-label]');
    this.expressBtn  = el.querySelector('[data-eng-stf-express]');
    this.expressLbl  = el.querySelector('[data-eng-stf-express-label]');
    this.ctaOffen    = el.querySelector('[data-eng-stf-cta-offen]');
    this.expressOffen= el.querySelector('[data-eng-stf-express-offen]');
    this.ctaFuell    = el.querySelector('[data-eng-stf-fuell]');
    this.hinweis     = el.querySelector('[data-eng-stf-hinweis]');

    /* Halter der dauerhaft offenen Farbwahl (nur mit dem Schalter farbe_oben
       vorhanden, siehe engori-staffel.liquid). Er bleibt in JEDER Stufe sichtbar
       (Werner, 26.09.2026: "die variantenanzeige soll oben trotzdem bleiben"),
       ist seit 27.09.2026 aber NICHT mehr an Tasche 1 gebunden (Dateikopf). */
    this.halter = el.querySelector('[data-eng-stf-picker-halter]');

    /* Filter-Dimensionen = alle Optionen ausser der eindeutigen */
    this.filterIdx = data.optionNames
      .map(function (_, i) { return i; })
      .filter(function (i) { return i !== this.uniqIdx; }, this);

    this.themeForm = document.querySelector('product-form.main-product-form');
    this.expressWrap = this.themeForm ? this.themeForm.querySelector('.eng-express') : null;

    /* Warenkorbbasierte Express-Zahlarten (snippets/engori-express-korb.liquid).
       Sie bezahlen den Warenkorb, nicht die im Formular stehende Variante, und
       sind deshalb der einzige Express-Weg, sobald schon etwas drin liegt.
       korbMenge kennt beim Start noch nichts — leseKorb() traegt den Stand nach. */
    this.xkorb = document.querySelector('[data-eng-xkorb]');
    this.xkorbMenge = this.xkorb ? this.xkorb.querySelector('[data-eng-xkorb-menge]') : null;
    this.korbMenge = 0;

    /* Erst jetzt einblenden: ohne JS waere der Knopf tot, und das
       Theme-Kaufformular bleibt in dem Fall der einzige Weg. */
    if (this.submitBtn) this.submitBtn.hidden = false;
    if (this.hinweis) this.hinweis.hidden = false;
    this.verdeckeThemeFormular();

    this.bind();
    this.wechsel();
    this.leseKorb();
  }

  /* Stand des Warenkorbs vom Server holen und uebernehmen. Notwendig beim
     Aufbau der Seite: Liquid rendert den Block, kennt aber beim Ausliefern aus
     dem Cache nicht zwingend den aktuellen Warenkorb — /cart.js schon.
     Faellt der Aufruf aus, bleibt korbMenge auf 0 und der Block verborgen; das
     ist der Zustand von vor dem 06.09.2026 und damit unschaedlich. */
  Staffel.prototype.leseKorb = function () {
    var self = this;
    if (!this.xkorb) return;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (korb) { self.uebernehmeKorb(korb); })
      .catch(function () { /* ohne Antwort bleibt der Block aus */ });
  };

  /* Warenkorbstand uebernehmen: Stueckzahl in die Zeile ueber den Knoepfen und
     Sichtbarkeit neu entscheiden.

     Die Stueckzahl steht dort, weil die Seite gleichzeitig eine Stufe anzeigt,
     die noch NICHT im Warenkorb liegen muss. Ohne diese Angabe koennte der
     Kunde die gewaehlte Stufe fuer den Korbinhalt halten und mit einem Klick
     etwas anderes bezahlen, als vor ihm steht. Wortlaut wie im Popup
     ("1 Tasche" / "n Taschen"), damit auf der Seite nicht zwei Zaehlweisen
     nebeneinander stehen. */
  Staffel.prototype.uebernehmeKorb = function (korb) {
    this.korbMenge = (korb && korb.item_count) || 0;
    if (this.xkorbMenge) {
      this.xkorbMenge.textContent = this.korbMenge === 1
        ? '1 Tasche im Warenkorb'
        : this.korbMenge + ' Taschen im Warenkorb';
    }
    this.setzeExpressModus();
  };

  /* Sobald die Staffel bedienbar ist, darf das Kaufformular des Themes nicht
     danebenstehen: es legt immer genau 1 Stueck und wuerde bei Stufe 2 oder 3
     eine andere Menge in den Warenkorb bringen, als die Seite anzeigt.
     Verdeckt werden aber nur Fehlerbox und Knopfreihe — der Express-Container
     .eng-express bleibt im Formular stehen, weil die Wallet-Knoepfe darin nur
     dort funktionieren, wo sie gerendert wurden. (Ein Umhaengen im DOM laedt
     das Wallet-Iframe neu; das ist unnoetiges Risiko.)
     Der Varianten-Picker ist ein eigener Block und bleibt sichtbar; sein
     verstecktes Feld .product-variant-id wird weiter gepflegt und hier
     ausgelesen. Findet sich das Formular nicht, bleibt alles wie es ist. */
  Staffel.prototype.verdeckeThemeFormular = function () {
    if (this.themeForm) this.themeForm.classList.add('eng-stf-verdeckt');
  };

  /* Aktuell auf der Produktseite gewaehlte Variante. Das Theme pflegt dieses
     Feld bei jedem Variantenwechsel — verlaesslicher als der Serverstand aus
     dem JSON-Block, der nur den Zustand beim Rendern kennt. */
  Staffel.prototype.aktuelleVariante = function () {
    var ausPicker = this.pickerVariante();
    if (ausPicker) return ausPicker;
    var feld = document.querySelector('product-form.main-product-form .product-variant-id');
    var id = feld ? parseInt(feld.value, 10) : 0;
    if (id && this.byId(id)) return id;
    return this.data.selected || 0;
  };

  /* Variante, die der Picker gerade ZEIGT — aus seinen markierten Werten
     abgeleitet, nicht aus `.product-variant-id`. Das Feld traegt in den
     Buendelstufen Tasche 1 und ist dort nicht die Wahl des Pickers. */
  Staffel.prototype.pickerVariante = function () {
    var picker = document.querySelector('variant-selects, variant-picker');
    if (!picker) return 0;
    var werte = [];
    Array.prototype.forEach.call(picker.querySelectorAll('input[type="radio"]:checked, select'), function (el) {
      if (el.value) werte.push(el.value);
    });
    if (!werte.length) return 0;
    var treffer = this.data.variants.filter(function (v) {
      return v.opts.length === werte.length && v.opts.every(function (o) { return werte.indexOf(o) !== -1; });
    })[0];
    return treffer ? treffer.id : 0;
  };

  Staffel.prototype.byId = function (id) {
    return this.data.variants.filter(function (v) { return v.id === id; })[0] || null;
  };

  /* ── Galeriebild zur angeklickten Farbkachel ──────────────────────────────
     Wunsch Werner 10.09.2026: "wenn ich die swatches anklicke moechte ich das
     das jeweilige produktbild auch angezeigt wird".

     Vorher blieb die Galerie stehen, sobald die Farbe ueber eine Kachel der
     Staffel kam. Grund: Die Kacheln sind nicht der Theme-Picker. Das Theme
     schaltet das Bild in VariantSelects.updateMedia() um, und die laeuft nur
     bei einem 'change' im <variant-selects>. In Stufe 1 passiert das (der
     Picker steht dort im Panel und funktioniert), in Stufe 2 und 4 nicht —
     dort waehlt der Kunde ueber die Kacheln.

     Kein zweiter Mechanismus daneben: Umgeschaltet wird ueber genau dieselbe
     Methode, die auch das Theme benutzt — media-gallery.setActiveMedia(). Die
     Argumente werden nicht erfunden, sondern am <variant-selects> abgelesen
     (prependMedia, filtering), und die Variante kommt aus dessen eigener
     Datenquelle getVariantData(). Dadurch kann hier nichts von der Theme-
     Logik abweichen, auch wenn Shrine seine Einstellungen aendert.

     ⚠️ Was hier ausdruecklich NICHT passiert: das Produktformular anfassen.
     Bei Stufe 2 und 4 traegt setzeFormularPosten() die Hauptvariante in
     .product-variant-id und die uebrigen Farben als Zusatzpositionen ein.
     Wuerde die Bildumschaltung den Picker mitziehen (etwa ueber einen Klick
     auf sein Radio, wie es engori-sticky-extras.js tut), schriebe dessen
     updateVariantInput() in dasselbe Feld — die Bestellung koennte dann eine
     andere Farbe tragen als die Anzeige. Deshalb wird ausschliesslich die
     Galerie umgeschaltet, nichts sonst.                                     */
  Staffel.prototype.zeigeVariantenbild = function (variantId) {
    var vs = document.querySelector('variant-selects');
    if (!vs || typeof vs.getVariantData !== 'function') return;

    var daten;
    try { daten = vs.getVariantData(); } catch (e) { return; }
    if (!daten || !daten.length) return;

    var v = null;
    for (var i = 0; i < daten.length; i++) {
      if (daten[i].id === variantId) { v = daten[i]; break; }
    }

    /* Variante ohne eigenes Bild: Galerie bleibt stehen. Ein Sprung auf
       irgendein Bild waere schlechter als gar keine Bewegung. */
    if (!v || !v.featured_media || !v.featured_media.id) return;

    var sektion = vs.dataset.section;
    if (!sektion) return;
    var mediaId = sektion + '-' + v.featured_media.id;

    var galerien = document.querySelectorAll('[id^="MediaGallery-' + sektion + '"]');
    Array.prototype.forEach.call(galerien, function (g) {
      if (typeof g.setActiveMedia !== 'function') return;
      /* Fehlt der Slide, liefe setActiveMedia in einen Zugriff auf null und
         risse die ganze Klickbehandlung mit — dann lieber nichts tun. */
      if (!g.querySelector('[data-media-id="' + mediaId + '"]')) return;
      g.setActiveMedia(mediaId, vs.prependMedia, vs.filtering, v);
    });
  };

  /* Varianten, die zu den Filtern eines Slots passen und lieferbar sind */
  Staffel.prototype.matchingFor = function (slot) {
    var self = this;
    return this.data.variants.filter(function (v) {
      if (!v.available) return false;
      return self.filterIdx.every(function (fi) {
        return !slot.filters[fi] || v.opts[fi] === slot.filters[fi];
      });
    });
  };

  /* Werte einer Filter-Dimension, die mit den uebrigen Filtern erreichbar sind */
  Staffel.prototype.valuesFor = function (slot, dim) {
    var self = this, seen = [];
    this.data.variants.forEach(function (v) {
      if (!v.available) return;
      var ok = self.filterIdx.every(function (fi) {
        return fi === dim || !slot.filters[fi] || v.opts[fi] === slot.filters[fi];
      });
      if (ok && seen.indexOf(v.opts[dim]) === -1) seen.push(v.opts[dim]);
    });
    return seen;
  };

  /* Vorausgewaehlt ist die ERSTE Farbe der Reihe (07.09.2026). Zuvor wurde die
     meistverkaufte Farbe gesucht — das traf bei jedem Produkt eine andere Kachel
     und der Auswahlring sass mal hier, mal dort. Die erste Kachel ist bei jedem
     Produkt dieselbe Stelle, und die Reihenfolge steuerst du im Admin.

     Vorausgewaehlt wird ueberhaupt, damit die Auswahl vom ersten Moment an
     vollstaendig ist — sonst bleibt der Kaufknopf gesperrt und die
     Express-Zahlarten koennen nicht erscheinen.

     Die Vorauswahl wird sichtbar markiert (der Platz traegt `is-done`, die
     Kachel ist als gewaehlt gezeichnet). Das ist der Unterschied zum Fehler
     vom 04.09.2026, als eine unsichtbar vorbelegte schwarze Tasche im
     Warenkorb landete, ohne dass jemand sie gewaehlt hatte. */

  /* Ein neuer Farbplatz startet mit der ersten lieferbaren Variante (27.09.2026)
     und OHNE Merker: `vomKunden: false` heisst „diese Farbe hat niemand
     eingestellt, der Picker oben darf sie mitziehen" (koppleNachUnten, 29.09.).
     Gleich nach dem Aufbau laeuft die Kopplung, der Platz traegt also in der
     Praxis die oben gezeigte Farbe. */
  Staffel.prototype.neuerSlot = function () {
    var erste = this.data.variants.filter(function (v) { return v.available; })[0] || null;
    var filters = {};
    if (erste) {
      this.filterIdx.forEach(function (fi) { filters[fi] = erste.opts[fi]; });
    }
    var slot = { filters: filters, variantId: null, vomKunden: false };
    var kandidaten = this.matchingFor(slot);
    if (kandidaten.length) slot.variantId = kandidaten[0].id;
    return slot;
  };

  /* ── Wahl oben in die Farbplaetze uebernehmen (29.09.2026) ────────────────
     Werner: „die in 1+1 auch mit ausgewaehlt sind es sei denn die wurden
     eingestellt". Also: jeder Platz OHNE `vomKunden` folgt der Farbe, die der
     Picker oben zeigt; ein selbst gesetzter Platz bleibt, wie er ist.

     Drei Vorkehrungen gegen ein Aufschaukeln:
     1. Nur eine Richtung. Diese Methode ruft ausschliesslich render() und
        aktualisiere() — nichts davon klickt im Picker oder verschickt
        `engori:staffel:wahl`. Ein Rueckweg nach oben existiert nicht.
     2. Vergleichen, bevor gesetzt wird. Traegt kein Platz etwas Anderes, endet
        die Methode ohne Neuzeichnen (`if (!aend) return`).
     3. Ein Riegel gegen Wiedereintritt, falls ein spaeterer Umbau doch einmal
        ein Ereignis ausloest.                                                */
  Staffel.prototype.koppleNachUnten = function () {
    if (this.koppelLaeuft) return;
    if (this.menge < 2 || !this.slots.length) return;

    var id = this.pickerVariante();
    if (!id) return;
    var v = this.byId(id);
    if (!v) return;

    var self = this, aend = false;
    this.slots.forEach(function (slot) {
      if (slot.vomKunden) return;
      if (slot.variantId === id) return;
      slot.variantId = id;
      self.filterIdx.forEach(function (fi) { slot.filters[fi] = v.opts[fi]; });
      aend = true;
    });
    if (!aend) return;

    this.koppelLaeuft = true;
    try {
      this.render();
    } finally {
      this.koppelLaeuft = false;
    }
  };

  /* Das Panel der gewaehlten Stufe, oder null */
  Staffel.prototype.aktivesPanel = function () {
    var nr = String(this.stufe);
    return this.panels.filter(function (p) {
      return p.getAttribute('data-eng-stf-panel') === nr;
    })[0] || null;
  };

  /* Stufenwechsel: genau ein Klappbereich offen, Slots auf die neue Menge
     bringen. Schon getroffene Farbwahlen bleiben erhalten — wer von 2 auf 4
     wechselt, soll nicht von vorn anfangen. */
  Staffel.prototype.wechsel = function () {
    var gewaehlt = this.radios.filter(function (r) { return r.checked; })[0] || this.radios[0];
    if (!gewaehlt) return;

    this.menge = parseInt(gewaehlt.dataset.engStfMenge, 10) || 1;
    this.stufe = parseInt(gewaehlt.value, 10) || 1;
    this.el.classList.toggle('eng-stf--buendel', this.menge > 1);

    /* Beim ersten Durchlauf schweigen: eine aria-live-Region meldet
       AENDERUNGEN. Waere sie schon beim Seitenaufbau gefuellt, laese die
       Vorlesesoftware den Satz vor, ohne dass der Kunde etwas getan hat. */
    if (this.ansage && !this.erstlauf) {
      this.ansage.textContent = gewaehlt.dataset.engStfSage || '';
    }
    this.erstlauf = false;

    /* Akkordeon: nur der Bereich der gewaehlten Stufe steht offen. `hidden`
       statt display:none, damit der zugeklappte Teil auch fuer Vorlesesoftware
       und Tastatur weg ist und nicht nur unsichtbar. */
    var nr = String(this.stufe);

    /* Die gewaehlte Stufe ist immer offen — auch auf dem Handy.

       ⚠️ ZURUECKGENOMMEN am 05.09.2026, wenige Stunden nach dem Einbau.
       Auf Wunsch (Werner, 05.09.2026) blieb hier beim ersten Aufbau unter
       750 px alles zugeklappt, damit die Kaufbox kuerzer wirkt. Die Folge war
       ein toter Shop auf jedem Telefon: Stufe 2 ist vorausgewaehlt und
       verlangt zwei Farben, der Kaufknopf steht also gesperrt mit "Noch 2
       Farben waehlen" da — waehrend gar keine Farbe zu sehen ist. Der Kunde
       haette erst eine Stufe antippen muessen, um ueberhaupt kaufen zu
       koennen. Gemessen bei 375, 480, 600 und 749 px: alle drei Bereiche
       trugen `hidden`.

       Wer die Kaufbox wieder verkuerzen will, darf das nicht ueber den
       Anfangszustand loesen, sondern muss den gesperrten Kaufknopf die
       Farbauswahl oeffnen lassen. Sonst steht wieder ein Knopf da, der etwas
       verlangt, das der Kunde nicht sieht. */
    this.erstAufbau = false;

    this.panels.forEach(function (p) {
      p.hidden = p.getAttribute('data-eng-stf-panel') !== nr;
    });

    while (this.slots.length > this.menge) this.slots.pop();
    while (this.slots.length < this.menge) this.slots.push(this.neuerSlot());

    this.openSlot = null;
    this.hideError();

    /* Bei einer Einzelstufe gibt es nichts zu verteilen — die Farbe steht
       schon im Varianten-Picker daruber. */
    if (this.menge < 2) {
      this.panels.forEach(function (p) {
        var w = p.querySelector('[data-eng-stf-slots]');
        if (w) w.innerHTML = '';
      });
    } else {
      this.render();
    }

    /* 26.09.2026 (Werner): "wenn ich den bundle 1 auswähle soll die erste
       Tasche ausgewählt sein". Bei einer Tasche ist die Auswahl oben die
       einzige, sie wird also sichtbar markiert. Bei zwei und vier fuehren die
       Karten, oben steht dann wieder "noch offen" — sonst zaehlt der Kunde
       drei Markierungen fuer zwei Taschen. Beim Seitenaufbau (erstlauf)
       passiert nichts, damit die Vorauswahl unmarkiert bleibt.
       ⚠️ Hier wird nur die ANZEIGE oben umgestellt. Der frueher an dieser
       Stelle gebaute Schau-Modus (Panel der Zweierstufe sichtbar lassen und
       mit `inert` sperren) hat den Shop verkaufsunfaehig gemacht: das Panel
       steckt in der anklickbaren Stufenkarte, `inert` sperrte damit auch das
       Umschalten aufs Buendel. Nicht wieder einbauen. */
    if (!this.erstlauf) {
      document.dispatchEvent(new CustomEvent('engori:staffel:stufe', {
        detail: { menge: this.menge }
      }));
    }

    this.aktualisiere();
  };

  /* Die drei Anzeigen, die vom Zustand abhaengen, immer gemeinsam nachziehen.
     Frueher standen sie einzeln am Ende von wechsel(); seit die Farbwahl in
     Stufe 1 den Kaufweg sperrt, muss derselbe Block auch nach einem Klick im
     Varianten-Picker laufen — sonst zeigt der Knopf einen Zustand, der nicht
     mehr gilt. */
  Staffel.prototype.aktualisiere = function () {
    this.zeigePflicht();
    this.setzeExpressModus();
    this.syncCta();
  };

  /* Stufe 1 hat keine eigenen Farbkacheln: sie nutzt den Varianten-Picker, der
     in ihren Klappbereich verschoben wird (pickerEinhaengen weiter unten).
     Shopify waehlt dort beim Seitenaufbau immer eine Variante vor — der Kunde
     hat also noch nichts entschieden, das Formular traegt aber bereits eine ID.
     wahlAnzeige() setzt `data-eng-gewaehlt`, sobald wirklich geklickt wurde;
     bis dahin gilt die Wahl hier als offen.

     Die Sperre haengt bewusst an `data-eng-wahl-aktiv`: Kommt die Wahlanzeige
     nicht zustande (kein Picker, keine Beschriftung), wird `data-eng-gewaehlt`
     nie gesetzt — dann darf der Kaufknopf nicht fuer immer tot bleiben. Ohne
     aktive Wahlanzeige gibt es also keine Sperre. */
  Staffel.prototype.einzelWahlOffen = function () {
    var picker = document.querySelector('.eng-stf .eng-stf__picker[data-eng-wahl-aktiv]');
    if (!picker) return false;
    return !picker.hasAttribute('data-eng-gewaehlt');
  };

  /* Pflichthinweis der aktiven Stufe zeigen und ueber die Express-Zahlarten
     spiegeln. Der Text kommt aus Liquid — hier wird nur umgeschaltet. */
  Staffel.prototype.zeigePflicht = function () {
    var nr = String(this.stufe);
    var aktiv = null;
    this.pflichtAbs.forEach(function (p) {
      var an = p.getAttribute('data-eng-stf-pflicht') === nr;
      p.hidden = !an;
      if (an) aktiv = p;
    });
    if (aktiv) this.beschrifteAuswahl(aktiv);
  };

  /* Gleiche Farben zusammenziehen (07.09.2026): Bei vier schwarzen Taschen stand
     viermal derselbe Name in der Zeile und erzwang eine dritte Textzeile.
     Jetzt: "4 × Schwarz". Gemischt wird nach dem ersten Auftreten sortiert
     ("2 × Schwarz, Grau"), und eine einzelne Tasche einer Farbe bekommt keine
     Zahl vorangestellt — "1 × Grau" liest sich umstaendlicher als "Grau". */
  function fasseFarben(namen) {
    var reihenfolge = [];
    var anzahl = {};
    namen.forEach(function (n) {
      if (!(n in anzahl)) { anzahl[n] = 0; reihenfolge.push(n); }
      anzahl[n] += 1;
    });
    return reihenfolge.map(function (n) {
      return anzahl[n] > 1 ? anzahl[n] + ' × ' + n : n;
    }).join(', ');
  }

  /* Die Zeile ueber dem Kaufknopf sagt, WAS gekauft wird: "Auswahl:", die
     gewaehlten Farben, dann die Preisangaben.

     07.09.2026, zweiter Anlauf: Bis eben stand diese Angabe ZWEIMAL da — einmal
     schlicht ueber dem Kaufknopf, einmal als Kopie mit "Auswahl:" ueber den
     Zahlarten. Jetzt gibt es nur noch die eine, oben (Wunsch Werner). Die Kopie
     unten faellt ersatzlos weg.

     Muss mehrfach aufrufbar bleiben: Die Zeilen stehen fest im Liquid und
     werden nicht neu gerendert, also raeumt die Funktion ihre eigenen Zusaetze
     erst weg, bevor sie neue setzt. Sonst stuende nach dem dritten
     Stufenwechsel dreimal "Auswahl:" da. */
  Staffel.prototype.beschrifteAuswahl = function (zeile) {
    if (!zeile) return;
    var self = this;
    var namen = [];

    Array.prototype.slice.call(
      zeile.querySelectorAll('.eng-stf__pflicht-label, .eng-stf__pflicht-farben')
    ).forEach(function (el) { el.parentNode.removeChild(el); });
    if (this.menge < 2) {
      var einzeln = this.byId(this.aktuelleVariante());
      if (einzeln && !this.einzelWahlOffen()) namen.push(cleanLabel(einzeln, this.uniqIdx));
    } else {
      this.slots.forEach(function (s) {
        var v = s.variantId ? self.byId(s.variantId) : null;
        if (v) namen.push(cleanLabel(v, self.uniqIdx));
      });
    }

    var kopf = document.createElement('span');
    kopf.className = 'eng-stf__pflicht-label';
    kopf.textContent = 'Auswahl:';
    zeile.insertBefore(kopf, zeile.firstChild);

    if (!namen.length) return;
    var farben = document.createElement('span');
    farben.className = 'eng-stf__pflicht-farben';
    farben.textContent = fasseFarben(namen);
    var menge = zeile.querySelector('.eng-stf__pflicht-menge');
    if (menge && menge.nextSibling) {
      zeile.insertBefore(farben, menge.nextSibling);
    } else {
      zeile.appendChild(farben);
    }
  };

  /* Die Positionen, die ein Express-Kauf jetzt umfassen wuerde — oder null,
     solange die Auswahl unvollstaendig ist. Eine Stelle, die fuer alle drei
     Stufen dieselbe Frage beantwortet: "Steht fest, was gekauft wird?"

     Stufe 1 nimmt die Variante aus dem Formular, aber erst nachdem der Kunde im
     Varianten-Picker selbst geklickt hat (einzelWahlOffen) — Shopifys
     Vorauswahl allein ist keine Entscheidung.
     Stufe 2 und 4 nehmen die Farben der Farbplaetze, in genau der Reihenfolge,
     in der sie in der Kaufbox stehen. */
  Staffel.prototype.expressPosten = function () {
    if (this.menge < 2) {
      if (this.einzelWahlOffen()) return null;
      var id = this.aktuelleVariante();
      return id ? [id] : null;
    }
    if (this.slots.length !== this.menge) return null;
    var ids = this.slots.map(function (s) { return s.variantId; });
    if (ids.some(function (i) { return !i; })) return null;
    return ids;
  };

  /* Versteckte Felder fuer die Zusatzpositionen ins Produktformular schreiben
     (oder alle wieder herausnehmen, wenn ids null oder einelementig ist).

     Feldnamen und Indexbeginn stehen nicht hier, sondern in der Doku — siehe
     Kopf dieser Datei. Jedes von uns erzeugte Feld traegt data-eng-zusatz,
     damit dieselbe Funktion ihre eigenen Felder sicher wiederfindet und keine
     fremden anfasst.

     Die Hauptvariante wird ueber die PROPERTY .value gesetzt, nicht ueber
     setAttribute: der MutationObserver in bind() horcht auf das Attribut und
     wuerde sonst bei jedem Wechsel die Filter der offenen Farbplaetze
     nachziehen — eine Aenderung, die der Kunde nicht ausgeloest hat. */
  Staffel.prototype.setzeFormularPosten = function (ids) {
    var form = this.themeForm ? this.themeForm.querySelector('form') : null;
    if (!form) return;

    var alt = form.querySelectorAll('[data-eng-zusatz]');
    Array.prototype.forEach.call(alt, function (n) { n.parentNode.removeChild(n); });

    var feld = form.querySelector('.product-variant-id');

    /* Hauptposition immer setzen, auch bei nur einer ID: nach einem
       Picker-Klick steht dort sonst die Picker-Variante (Buendel) bzw. noch
       Tasche 1 (zurueck auf Stufe 1). 27.09.2026. */
    if (!ids || !ids.length) return;
    if (feld) feld.value = String(ids[0]);

    for (var i = 1; i < ids.length; i++) {
      form.appendChild(feldZusatz('shopify-additional-items[' + i + '][id]', ids[i]));
      form.appendChild(feldZusatz('shopify-additional-items[' + i + '][quantity]', 1));
    }
  };

  /* Die eine Stelle, die ueber beide Knopfarten entscheidet.

     Native Knoepfe (.eng-express, aus `{{ form | payment_button }}`): an,
     sobald feststeht, was gekauft wird — fuer alle drei Stufen, seit sie
     Zusatzpositionen tragen koennen (Beleg im Dateikopf).

     Sie treten nur ab, wenn schon etwas im Warenkorb liegt: sie kaufen den
     Inhalt des FORMULARS und gehen am Korbinhalt vorbei — der Kunde zahlte
     weniger, als er im Korb hat, und merkte es erst in der Bestaetigung. Dann
     uebernimmt .eng-xkorb, das den Warenkorb bezahlt. Beide gleichzeitig waere
     schlimmer als jede Einzelvariante: gleiche Zahlungslogos, zwei Betraege. */
  Staffel.prototype.setzeExpressModus = function () {
    /* Erst zuruecksetzen, dann neu bestuecken. Sonst laese expressPosten() bei
       einem Stufenwechsel die Hauptvariante der VORIGEN Stufe aus dem Feld. */
    this.setzeFormularPosten(null);

    var posten = this.expressPosten();
    var korbVoll = this.korbMenge > 0;
    var nativAus = !posten || korbVoll;

    if (!nativAus) {
      this.setzeFormularPosten(posten);
    } else if (this.menge < 2) {
      var einzel = this.aktuelleVariante();
      if (einzel) this.setzeFormularPosten([einzel]);
    }

    if (this.themeForm) {
      this.themeForm.classList.toggle('eng-stf-express-aus', nativAus);
    }
    if (this.expressBtn) this.expressBtn.hidden = this.menge < 2;
    if (this.xkorb) this.xkorb.hidden = !korbVoll;
  };

  /* ── Farbwahl der Buendelstufen: eine Zeile je Tasche + Popup ─────────────
     Neu 27.09.2026 (Vorgabe Haendler, Vorbild Nordstealth): Statt offener
     Kachelraster je Tasche steht pro Tasche EINE Zeile "1. [Bild Farbe ▾]".
     Der kleine Knopf oeffnet ein Popup mit den Farbkugeln (bei Curved und
     Umhaengetasche oben zusaetzlich Rechts/Links). Wahl = Popup zu, Zeile
     zeigt Bild und Farbname. Jede Tasche ist vorbelegt, der Kaufknopf ist
     also sofort bedienbar. */
  Staffel.prototype.anzeigeName = function (v) {
    var self = this;
    var name = cleanLabel(v, this.uniqIdx);
    var seite = this.filterIdx
      .filter(function (fi) { return /seite/i.test(self.data.optionNames[fi] || ''); })
      .map(function (fi) { return v.opts[fi]; });
    return seite.length ? name + ' · ' + seite.join(' · ') : name;
  };

  Staffel.prototype.render = function () {
    var self = this;
    var panel = this.aktivesPanel();
    if (!panel) return;
    var wrap = panel.querySelector('[data-eng-stf-slots]');
    if (!wrap) return;

    this.panels.forEach(function (p) {
      if (p === panel) return;
      var w = p.querySelector('[data-eng-stf-slots]');
      if (w) w.innerHTML = '';
    });
    wrap.innerHTML = '';

    this.slots.forEach(function (slot, si) {
      var v = slot.variantId ? self.byId(slot.variantId) : null;
      var zeile = document.createElement('div');
      zeile.className = 'eng-stf__zeile';

      var nr = document.createElement('span');
      nr.className = 'eng-stf__zeile-nr';
      nr.textContent = (si + 1) + '.';
      zeile.appendChild(nr);

      var knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'eng-stf__wahl' + (v ? '' : ' is-offen');
      knopf.setAttribute('aria-haspopup', 'dialog');
      knopf.dataset.engWahl = String(si);
      knopf.setAttribute('aria-label', 'Tasche ' + (si + 1) + ': ' + (v ? self.anzeigeName(v) : 'Farbe wählen') + ' – ändern');
      knopf.innerHTML =
        (v && v.img ? '<img src="' + v.img + '" alt="" width="30" height="30" loading="lazy">' : '<span class="eng-stf__wahl-leer" aria-hidden="true"></span>') +
        '<span class="eng-stf__wahl-name"></span>' +
        '<svg class="eng-stf__wahl-pfeil" viewBox="0 0 12 8" aria-hidden="true"><path d="M1 1.5l5 5 5-5" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      knopf.querySelector('.eng-stf__wahl-name').textContent = v ? self.anzeigeName(v) : 'Farbe wählen';
      zeile.appendChild(knopf);
      wrap.appendChild(zeile);
    });

    this.aktualisiere();
  };

  /* Popup einmal je Staffel bauen und an body haengen (position: fixed darf
     nicht in einem transformierten Vorfahren stecken). */
  Staffel.prototype.popBauen = function () {
    if (this.pop) return this.pop;
    var self = this;
    var pop = document.createElement('div');
    pop.className = 'eng-pop';
    pop.hidden = true;
    pop.innerHTML =
      '<div class="eng-pop__hinter" data-eng-pop-zu></div>' +
      '<div class="eng-pop__karte" role="dialog" aria-modal="true" aria-labelledby="' + this.el.id + '-pop-titel">' +
        '<div class="eng-pop__kopf">' +
          '<p class="eng-pop__titel" id="' + this.el.id + '-pop-titel"></p>' +
          '<button type="button" class="eng-pop__zu" data-eng-pop-zu aria-label="Schließen">' +
            '<svg viewBox="0 0 14 14" aria-hidden="true"><path d="M2 2l10 10M12 2L2 12" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/></svg>' +
          '</button>' +
        '</div>' +
        '<div class="eng-pop__filter" data-eng-pop-filter></div>' +
        '<div class="eng-pop__raster" data-eng-pop-raster></div>' +
      '</div>';
    document.body.appendChild(pop);

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-eng-pop-zu]')) { self.popZu(); return; }
      var chip = e.target.closest('[data-eng-pop-dim]');
      if (chip) {
        self.popFilter[+chip.dataset.engPopDim] = chip.dataset.engPopWert;
        /* Auch der Chip (Rechts/Links) zaehlt als „selbst eingestellt" — der
           Kunde kuemmert sich um diesen Platz, der Picker oben zieht ihn ab
           jetzt nicht mehr mit (Werner, 29.09.2026). */
        if (self.slots[self.popSlot]) self.slots[self.popSlot].vomKunden = true;
        self.popZeichnen();
        return;
      }
      var k = e.target.closest('[data-eng-pop-id]');
      if (k) {
        var slot = self.slots[self.popSlot];
        var id = +k.dataset.engPopId;
        var v = self.byId(id);
        slot.variantId = id;
        /* Von Hand gesetzt: ab hier behaelt der Platz seine Farbe, auch wenn
           oben eine andere gewaehlt wird (koppleNachUnten). */
        slot.vomKunden = true;
        if (v) self.filterIdx.forEach(function (fi) { slot.filters[fi] = v.opts[fi]; });
        self.hideError();
        self.popZu();
        self.render();
        self.zeigeVariantenbild(id);
      }
    });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); self.popZu(); }
    });
    this.pop = pop;
    return pop;
  };

  Staffel.prototype.popAuf = function (si, ausloeser) {
    var pop = this.popBauen();
    var slot = this.slots[si];
    this.popSlot = si;
    this.popAusloeser = ausloeser || null;
    this.popFilter = {};
    var self = this;
    this.filterIdx.forEach(function (fi) { self.popFilter[fi] = slot.filters[fi]; });
    pop.querySelector('.eng-pop__titel').textContent = 'Tasche ' + (si + 1) + ': Farbe wählen';
    this.popZeichnen();
    pop.hidden = false;
    document.documentElement.classList.add('eng-pop-offen');
    var an = pop.querySelector('.eng-pop__kachel.is-on') || pop.querySelector('.eng-pop__kachel');
    if (an) an.focus({ preventScroll: true });
  };

  Staffel.prototype.popZu = function () {
    if (!this.pop || this.pop.hidden) return;
    this.pop.hidden = true;
    document.documentElement.classList.remove('eng-pop-offen');
    var si = this.popSlot;
    var knopf = this.el.querySelector('[data-eng-wahl="' + si + '"]');
    if (knopf) knopf.focus({ preventScroll: true });
  };

  Staffel.prototype.popZeichnen = function () {
    var self = this;
    var pop = this.pop;
    var slot = this.slots[this.popSlot];
    var probe = { filters: this.popFilter, variantId: slot.variantId };

    var filter = pop.querySelector('[data-eng-pop-filter]');
    filter.innerHTML = '';
    this.filterIdx.forEach(function (dim) {
      var werte = self.valuesFor(probe, dim);
      if (werte.length < 2) return;
      var reihe = document.createElement('div');
      reihe.className = 'eng-pop__chips';
      reihe.setAttribute('role', 'group');
      reihe.setAttribute('aria-label', (self.data.optionNames[dim] || '').replace(/:$/, ''));
      werte.forEach(function (w) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'eng-pop__chip' + (self.popFilter[dim] === w ? ' is-on' : '');
        b.setAttribute('aria-pressed', self.popFilter[dim] === w ? 'true' : 'false');
        b.dataset.engPopDim = String(dim);
        b.dataset.engPopWert = w;
        b.textContent = w;
        reihe.appendChild(b);
      });
      filter.appendChild(reihe);
    });
    filter.hidden = !filter.children.length;

    var raster = pop.querySelector('[data-eng-pop-raster]');
    raster.innerHTML = '';
    var liste = this.matchingFor(probe);
    if (!liste.length) {
      raster.innerHTML = '<p class="eng-pop__leer">Für diese Auswahl ist nichts lieferbar.</p>';
      return;
    }
    liste.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      var an = slot.variantId === v.id;
      b.className = 'eng-pop__kachel' + (an ? ' is-on' : '');
      b.setAttribute('aria-pressed', an ? 'true' : 'false');
      b.dataset.engPopId = String(v.id);
      b.innerHTML = (v.img ? '<img src="' + v.img + '" alt="" width="56" height="56" loading="lazy">' : '') + '<span></span>';
      b.querySelector('span').textContent = cleanLabel(v, self.uniqIdx);
      raster.appendChild(b);
    });
  };

  /* Beschriftung des Kaufknopfs je Stufe (12.09.2026, Parameter cta_stufen im
     Snippet, z. B. "2 Taschen in den Warenkorb, 49,90 EUR"). Der Text kommt
     fertig aus Liquid (Betrag ueber money) als data-eng-stf-cta an der Stufe.
     Fehlt das Attribut, bleibt es beim allgemeinen ctaLabel — Seiten ohne den
     Parameter aendern sich nicht. Nur Beschriftung: Menge, Warenkorb und
     Zahlarten laufen unveraendert. */
  Staffel.prototype.ctaText = function () {
    var r = this.radios.filter(function (x) { return x.checked; })[0];
    return (r && r.getAttribute('data-eng-stf-cta')) || this.data.ctaLabel;
  };

  Staffel.prototype.syncCta = function () {
    if (!this.submitBtn) return;

    /* Stufe 1 verhaelt sich wie Stufe 2 und 4: gesperrt, bis gewaehlt wurde.
       Frueher stand hier `disabled = false` ohne jede Pruefung — dadurch legte
       der Knopf die von Shopify vorausgewaehlte Farbe in den Warenkorb,
       waehrend die Seite noch "noch offen" anzeigte (gemeldet 05.09.2026). */
    if (this.menge < 2) {
      var einzelOffen = this.einzelWahlOffen();
      this.submitBtn.disabled = einzelOffen;
      this.submitLbl.textContent = this.ctaText();
      if (this.expressLbl) this.expressLbl.textContent = this.data.expressLabel;
      this.zeigeOffen(einzelOffen ? 'Noch 1 Farbe wählen' : null);
      this.setzeFuellung(einzelOffen ? 0 : 1);
      return;
    }

    var done = this.slots.filter(function (s) { return s.variantId; }).length;

    /* Fortschritt und Sperre zaehlen dieselben Plaetze: in den Mehrfachstufen
       fuehrt die Staffel alle Taschen selbst, auch Tasche 1 (Werner,
       26.09.2026). Die Auswahl oben gehoert allein zur Einzelstufe. */
    var panel = this.aktivesPanel();
    var fortschritt = panel ? panel.querySelector('[data-eng-stf-fortschritt]') : null;
    if (fortschritt) {
      fortschritt.textContent =
        this.data.farbwahlTitel + ': ' + done + ' von ' + this.menge + ' gewählt';
    }

    var complete = done === this.menge;
    var offen = 'Noch ' + (this.menge - done) + ' Farbe' + (this.menge - done === 1 ? '' : 'n') + ' wählen';

    /* Die Beschriftung bleibt in jedem Zustand stehen — der Knopf muss auch
       gesperrt noch sagen, wohin er fuehrt. Der offene Rest kommt als zweite
       Zeile dazu. */
    this.submitBtn.disabled = !complete;
    this.submitLbl.textContent = this.ctaText();

    if (this.expressBtn) {
      this.expressBtn.disabled = !complete;
      if (this.expressLbl) this.expressLbl.textContent = this.data.expressLabel;
    }

    this.zeigeOffen(complete ? null : offen);
    this.setzeFuellung(this.menge ? done / this.menge : 1);
  };

  /* Hinweiszeile unter der Beschriftung. null blendet sie aus. */
  Staffel.prototype.zeigeOffen = function (text) {
    [this.ctaOffen, this.expressOffen].forEach(function (el) {
      if (!el) return;
      el.textContent = text || '';
      el.hidden = !text;
    });
  };

  /* Fuellstand des Kaufknopfs als Anteil zwischen 0 und 1. */
  Staffel.prototype.setzeFuellung = function (anteil) {
    if (!this.ctaFuell) return;
    var v = Math.max(0, Math.min(1, anteil || 0));
    this.ctaFuell.style.width = (v * 100) + '%';
  };

  /* ⚠️ STILLGELEGT am 31.10.2026 — wird von nichts mehr gerufen.
     Nach dem Hinzufuegen faehrt jetzt die Warenkorb-Schublade aus (siehe
     submit() weiter unten, Werners Auftrag vom 31.10.2026). Diese Methode und
     ihr Markup (snippets/engori-korb-popup.liquid, nicht mehr eingehaengt)
     bleiben als Rueckweg stehen: wer das Popup zurueckholen will, haengt das
     Snippet wieder in snippets/engori-staffel.liquid ein und ruft hier
     zeigePopup(popup, korb) statt renderContents.

     Fuellt das Popup mit dem Stand des Warenkorbs und zeigt es an.
     Die Betraege kommen aus /cart.js in Cent; die Waehrung wird aus dem
     Pflichthinweis der Seite uebernommen, damit hier kein Format hart
     hinterlegt ist. */
  Staffel.prototype.zeigePopup = function (popup, korb) {
    var menge = popup.querySelector('[data-eng-kp-menge]');
    var betrag = popup.querySelector('[data-eng-kp-betrag]');
    var text = popup.querySelector('[data-eng-kp-text]');

    var stueck = korb.item_count || 0;

    /* Die Ueberschrift bleibt kurz und einzeilig — bei zwei Zeilen rutschte das
       Haekchen aus der Zeile (gesehen 06.09.2026). Die Stueckzahl steht ohnehin
       in der Zeile darunter. */
    if (text) text.textContent = 'In den Warenkorb gelegt';
    var mengeText = stueck === 1 ? '1 Tasche' : stueck + ' Taschen';
    if (menge) menge.textContent = mengeText;

    /* Betrag INKLUSIVE Versand — dieselbe Zahl wie im Warenkorb und auf dem
       Kasse-Knopf. Zeigte das Popup nur den Warenwert, stuende hier 49,90 und
       zwei Klicks weiter 54,89. Schwelle und Pauschale wie im Versandtarif
       (Profil "Dropsure Versicherter Premium Versand"). */
    var versand = korb.total_price >= 9500 ? 0 : 499;
    var betragText = this.geld(korb.total_price + versand);
    if (betrag) betrag.textContent = betragText;

    /* Die gelegten Taschen als kleine Bilder — je Position eine, bei Menge > 1
       mit Zahl daneben statt mehrfach. Die Bild-URL kommt aus /cart.js; `_80x`
       laesst Shopifys CDN die kleine Fassung ausliefern, statt das grosse
       Produktbild herunterzuladen und im Browser zu schrumpfen. */
    var bilder = popup.querySelector('[data-eng-kp-bilder]');
    if (bilder) {
      bilder.innerHTML = '';
      var posten = (korb.items || []).slice(0, 6);
      posten.forEach(function (p) {
        var fig = document.createElement('span');
        fig.className = 'eng-kp__bild';

        if (p.image) {
          var img = document.createElement('img');
          img.src = String(p.image).replace(/(\.[a-z]+)(\?|$)/i, '_80x$1$2');
          img.alt = p.variant_title || p.product_title || '';
          /* Kein `loading="lazy"`: Das Popup oeffnet in dem Moment, in dem die
             Bilder gebraucht werden — verzoegertes Laden liesse leere Kaesten
             stehen, gerade auf langsamen Verbindungen. Bei 34 px kostet das
             Sofortladen nichts. */
          img.decoding = 'async';
          fig.appendChild(img);
        }

        if ((p.quantity || 1) > 1) {
          var zahl = document.createElement('span');
          zahl.className = 'eng-kp__bild-zahl';
          zahl.textContent = p.quantity;
          fig.appendChild(zahl);
        }

        fig.title = (p.variant_title || p.product_title || '');
        bilder.appendChild(fig);
      });
      bilder.hidden = posten.length === 0;
    }

    /* Die Seite bleibt bedienbar: kein gesperrtes Scrollen, kein abdunkelnder
       Hintergrund. Das Popup haengt oben rechts am Warenkorbzeichen und stoert
       niemanden, der weiterlesen will (Wunsch Werner 06.09.2026). */
    popup.hidden = false;

    /* 25.09.2026, BFSG-04: Das Popup bekommt keinen Fokus (es ist nicht
       modal), also sagt die vorhandene Live-Region der Staffel das Ergebnis an
       — dieselben Zahlen, die das Popup zeigt. */
    if (this.ansage) {
      this.ansage.textContent = 'In den Warenkorb gelegt: ' + mengeText + ', ' + betragText;
    }

    var zu = function () { popup.hidden = true; };

    popup.querySelectorAll('[data-eng-kp-schliessen]').forEach(function (b) {
      b.addEventListener('click', zu, { once: true });
    });
    document.addEventListener('keydown', function esc(e) {
      if (e.key === 'Escape') { zu(); document.removeEventListener('keydown', esc); }
    });

    /* Klick irgendwo sonst auf der Seite schliesst es — aber erst ab dem
       naechsten Zyklus, sonst faengt derselbe Klick, der es geoeffnet hat,
       es sofort wieder zu. */
    window.setTimeout(function () {
      document.addEventListener('click', function weg(e) {
        if (popup.hidden) { document.removeEventListener('click', weg); return; }
        if (!popup.contains(e.target)) { zu(); document.removeEventListener('click', weg); }
      });
    }, 0);

    /* Kein Zeitschalter: Das Popup verschwindet erst, wenn der Kunde es
       schliesst oder daneben tippt. Ein Selbstschliesser nach neun Sekunden war
       am 06.09.2026 kurz eingebaut und wieder entfernt — wer die Seite liest
       und dann kaufen will, findet die beiden Knoepfe sonst nicht mehr vor. */
  };

  /* Cent in einen Betrag mit dem Format der Seite. Kein hart hinterlegtes
     Waehrungszeichen — das kommt aus den Shop-Einstellungen. */
  Staffel.prototype.geld = function (cent) {
    var n = (cent || 0) / 100;
    try {
      return n.toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });
    } catch (e) {
      return n.toFixed(2) + ' €';
    }
  };

  Staffel.prototype.showError = function (msg) {
    this.errorBox.textContent = msg;
    this.errorBox.hidden = false;
  };

  Staffel.prototype.hideError = function () {
    this.errorBox.hidden = true;
  };

  Staffel.prototype.bind = function () {
    var self = this;

    /* Echte Radio-Inputs: Pfeiltasten, Tab und Vorlesesoftware kommen vom
       Browser. Deshalb kein eigener Tastaturcode. */
    this.radios.forEach(function (r) {
      r.addEventListener('change', function () { self.wechsel(); });
    });

    this.el.addEventListener('click', function (e) {
      var wahl = e.target.closest('[data-eng-wahl]');
      if (wahl) { self.popAuf(+wahl.dataset.engWahl, wahl); return; }

      if (e.target.closest('[data-eng-stf-express]')) { self.submit(true); return; }
      if (e.target.closest('[data-eng-stf-submit]')) self.submit(false);
    });

    /* Picker oben geklickt. Stufe 1: Knopf, Hinweis und Zahlarten folgen der
       neuen Variante. Buendelstufen: erst die Farbplaetze nachziehen
       (koppleNachUnten, 29.09.2026 — vorher blieben sie unberuehrt), dann
       `.product-variant-id` neu setzen, das das Theme soeben auf die
       Picker-Variante gestellt hat. Reihenfolge ist wichtig: aktualisiere()
       schreibt Tasche 1 ins Feld, also muss Tasche 1 vorher stimmen.
       Zweimal, weil die Reihenfolge der change-Zuhoerer dem Shrine-Bundle
       gehoert. */
    var nachWahl = function () { self.koppleNachUnten(); self.aktualisiere(); };
    document.addEventListener('engori:staffel:wahl', function () {
      nachWahl();
      window.setTimeout(nachWahl, 60);
    });

  };

  /* zurKasse = true -> nach dem Ablegen direkt /checkout statt /cart.
     Das ist der Ersatzweg fuer die Express-Zahlarten bei Stufe 2 und 4. */
  Staffel.prototype.submit = function (zurKasse) {
    var self = this;
    var items;
    var lbl = zurKasse ? this.expressLbl : this.submitLbl;

    if (this.menge < 2) {
      /* Zweite Schranke hinter dem gesperrten Knopf: aktuelleVariante() traegt
         wegen Shopifys Vorauswahl IMMER eine ID, die Frage ist nur, ob der
         Kunde sie selbst gewaehlt hat. */
      if (this.einzelWahlOffen()) { this.showError('Bitte zuerst eine Farbe wählen.'); return; }
      var id = this.aktuelleVariante();
      if (!id) { this.showError('Bitte zuerst eine Farbe wählen.'); return; }
      items = [{ id: id, quantity: 1 }];
    } else {
      items = this.slots.map(function (s) { return { id: s.variantId, quantity: 1 }; });
      if (items.some(function (i) { return !i.id; })) {
        this.showError('Bitte für jede Tasche eine Farbe wählen.');
        return;
      }
    }

    if (this.submitBtn) this.submitBtn.disabled = true;
    if (this.expressBtn) this.expressBtn.disabled = true;
    if (lbl) lbl.textContent = 'Wird hinzugefügt …';
    this.hideError();

    /* Nach dem Hinzufuegen faehrt die Warenkorb-Schublade von rechts ein.

       Geaendert am 31.10.2026 (Werner: "kannst du mir hier den warenkorb so
       einstellen das es kein popup fenster mehr ist sndern an der seite raus
       faehrt"). Bis dahin stand hier das eigene kleine Popup
       (snippets/engori-korb-popup.liquid, 06.09.2026). Es ist nicht geloescht,
       nur nicht mehr eingehaengt — der Grund steht im Kopf des Snippets.

       Warum die Schublade jetzt geht, die Theme-Einblendung aber nie ging:
       `cart-notification.renderContents` liest `state.id` und sucht damit
       `[id="cart-notification-product-<id>"]`. Bei zwei oder vier Taschen in
       einem Zug gibt es kein einzelnes `state.id`, der Selektor wird
       `…-undefined` und es bricht ab ("Cannot read properties of null",
       gemessen 06.09.2026).
       `cart-drawer.renderContents` dagegen rendert gegen den FESTEN Selektor
       `#CartDrawer` und braucht `state.id` nur als Merker. Am Laufzeitobjekt
       der Schublade abgelesen (Vorschau-Theme 200937111896, 31.10.2026):
         getSectionsToRender() -> [{id:'cart-drawer', selector:'#CartDrawer'},
                                   {id:'cart-icon-bubble'}]
       Mehrfach-Hinzufuegen ist damit unkritisch.

       ⚠️ `renderContents` liest `state.sections[<id>]` und gibt den Inhalt
       ungeprueft an `getSectionInnerHTML` weiter. Fehlt `sections`, laeuft dort
       `DOMParser(...).querySelector('#CartDrawer')` auf null. Deshalb werden
       die Section-Namen MIT der add-Anfrage geschickt (Section Rendering API,
       derselbe Weg wie in engori-cart.js, Nachlege-Knopf) und vor dem Rendern
       wird geprueft, dass sie auch zurueckkamen.

       `renderContents` oeffnet die Schublade am Ende selbst (`this.open()`),
       deshalb wird hier kein zweites `open()` gerufen — das stiesse die
       Einfahr-Animation doppelt an.

       Gibt es keine Schublade — anderes cart_type, Landingpage-Layout ohne
       cart-drawer, oder der Kunde steht schon auf der Warenkorbseite —, bleibt
       es beim alten Verhalten: harter Sprung auf /cart. Der Weg zur Kasse
       (Express-Knopf) springt weiterhin direkt zum Checkout.

       Knopf und Beschriftung werden NUR im Fehlerfall zurueckgesetzt — sonst
       koennte ein zweiter Klick in der Wartezeit die Menge verdoppeln. */
    var einschub = document.querySelector('cart-drawer');
    var aufCartSeite = !!document.getElementById('main-cart-items');
    var kannEinschub = !zurKasse && !aufCartSeite && !!einschub &&
      typeof einschub.renderContents === 'function' &&
      typeof einschub.getSectionsToRender === 'function';

    var rumpf = { items: items };
    if (kannEinschub) {
      try {
        rumpf.sections = einschub
          .getSectionsToRender()
          .map(function (s) { return s.id; })
          .join(',');
        rumpf.sections_url = window.location.pathname;
      } catch (err) {
        kannEinschub = false;
      }
    }

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(rumpf)
    })
      .then(function (res) {
        return res.json().then(function (state) {
          if (!res.ok) throw new Error(state.description || state.message || 'Konnte nicht hinzugefügt werden.');
          return state;
        });
      })
      .then(function (state) {
        document.dispatchEvent(new CustomEvent('engori:staffel:added', { detail: { items: items } }));

        if (!kannEinschub || !state || !state.sections) {
          if (lbl) lbl.textContent = zurKasse ? 'Kasse wird geöffnet …' : 'Warenkorb wird geöffnet …';
          window.location.href = root() + (zurKasse ? 'checkout' : 'cart');
          return;
        }

        /* `is-empty` steht am <cart-drawer> selbst, nicht an `.drawer__inner`.
           renderContents raeumt nur Letzteres auf, und das Section-Rendering
           ersetzt bloss den Inhalt von #CartDrawer — die Klasse am Wirt bliebe
           also stehen. Folgen laut assets/base.css ab Zeile 7021:
           `cart-drawer.is-empty .drawer__header`, `.cart-drawer__body` und
           `.drawer__footer` bekommen `height: 0; overflow: hidden` — die
           Schublade fuehre leer aus, obwohl Ware drin liegt. Zusaetzlich
           greift `open()` dann auf `.drawer__inner-empty` zu, das es nach dem
           Rendern nicht mehr gibt. Deshalb hier weg. */
        einschub.classList.remove('is-empty');

        /* Damit `close()` den Fokus auf den Kaufknopf zurueckgibt:
           `close()` ruft `removeTrapFocus(this.activeElement)`, und `open()`
           setzt activeElement nur, wenn es ein Argument bekommt —
           renderContents ruft `open()` ohne. Also vorher setzen. */
        if (typeof einschub.setActiveElement === 'function' && self.submitBtn) {
          einschub.setActiveElement(self.submitBtn);
        }

        einschub.renderContents(state);

        if (lbl) lbl.textContent = self.ctaText();
        self.syncCta();

        /* Zahlen aus dem Warenkorb holen, nicht aus der add-Antwort: die
           Antwort von cart/add.js nennt nur die neuen Positionen, nicht den
           Gesamtbestand. Gebraucht wird er fuer die Zeile ueber den Knoepfen
           und fuer setzeExpressModus(). Zuletzt, damit setzeExpressModus() das
           letzte Wort ueber die Knopfreihe hat. */
        return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (korb) {
            self.uebernehmeKorb(korb);
          });
      })
      .catch(function (err) {
        self.showError(err.message);
        self.syncCta();
      });
  };

  /* --- Initialisierung ---------------------------------------------------- */
  /* Alle laufenden Staffeln der Seite. Gebraucht wird die Liste bisher nur vom
     pageshow-Handler weiter unten, der den Warenkorbstand nachliest. */
  var instanzen = [];

  function init() {
    document.querySelectorAll('[data-eng-stf-data]').forEach(function (script) {
      var id = script.getAttribute('data-eng-stf-data');
      var el = document.getElementById(id);
      if (!el || el.dataset.engStfReady) return;

      var data;
      try { data = JSON.parse(script.textContent); }
      catch (err) { console.error('[engori-staffel] Daten unlesbar', err); return; }
      if (!data.variants || !data.variants.length) return;

      instanzen.push(new Staffel(el, data));
      el.dataset.engStfReady = '1';
    });
  }

  /* Zurueck-Taste aus Warenkorb oder Kasse: Der Browser holt die Seite aus dem
     bfcache, komplett mit dem Warenkorbstand von vorhin. Hat der Kunde dort
     etwas entfernt, zeigte die Produktseite sonst weiter Zahlarten fuer einen
     Korb, den es so nicht mehr gibt. Nur bei `persisted` — beim normalen
     Aufbau erledigt das der Konstruktor. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    instanzen.forEach(function (s) { s.leseKorb(); });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  /* Theme-Editor: Bloecke werden nachgeladen */
  document.addEventListener('shopify:section:load', init);

  /* Der Verlauf am rechten Rand der Farbreihe soll nur erscheinen, wenn dort
     wirklich noch Kacheln stehen. Sonst wirkt eine vollstaendig sichtbare
     Auswahl grundlos angeschnitten. Wunsch Werner 04.09.2026. */
  function reihenRandPruefen(wurzel) {
    var reihen = (wurzel || document).querySelectorAll('.eng-stf .eng-bdl__grid, .eng-stf__picker .color-swatches-container');
    Array.prototype.forEach.call(reihen, function (r) {
      var voll = r.scrollWidth <= r.clientWidth + 2;
      if (voll) { r.setAttribute('data-eng-voll', ''); }
      else      { r.removeAttribute('data-eng-voll'); }
    });
  }
  window.addEventListener('resize', function () { reihenRandPruefen(); });
  document.addEventListener('DOMContentLoaded', function () { reihenRandPruefen(); });
  /* Filter für die beiden Seiten-Observer (Randverlauf hier, Farbnamen am
     Dateiende), 25.09.2026, CODE-07/PERF-07: Beobachtet wird weiter das ganze
     Dokument, gearbeitet aber nur, wenn eine Änderung in einer Staffel liegt
     oder eine enthält (Neuaufbau der Farbplätze, Picker-Umzug, Neurendern durch
     das Theme). Kopfzeile, Galerie und App-Widgets lösten vorher jedes Mal
     Messen und Durchsuchen aus. Direkte Anhänge an body lösen weiter aus,
     weil body die Staffel enthält. Bewusst ohne requestAnimationFrame (siehe
     Farbnamen-Block). */
  function inStaffel(l) {
    for (var i = 0; i < l.length; i++) {
      var t = l[i].target;
      if (t.nodeType === 1 && (t.closest('.eng-stf') || t.querySelector('.eng-stf'))) return true;
    }
    return false;
  }

  /* Nach jedem Neuaufbau der Kacheln erneut messen */
  new MutationObserver(function (liste) { if (inStaffel(liste)) reihenRandPruefen(); })
    .observe(document.documentElement, { childList: true, subtree: true });


  /* 25.09.2026 (CODE-19): preisblockVorschau() entfernt. Sie glich den
     Preisblock an `preis_vorschau` an; den Parameter übergab kein Template. */


  /* ── Varianten-Picker in die Stufe "1 Tasche" einhaengen ──────────────────
     Wunsch Werner 04.09.2026: Die Swatches sollen nicht mehr ueber den Stufen
     stehen, sondern im aufgeklappten Bereich der Einzelstufe.

     Der Picker wird VERSCHOBEN, nicht nachgebaut. Ein zweiter Farbwaehler
     waere eine zweite Wahrheit: Die nativen Express-Knoepfe folgen immer dem
     Picker im Produktformular. Wer im Panel Blau waehlt, waehrend der Picker
     auf Schwarz steht, kauft per PayPal Schwarz. Durch das Verschieben bleibt
     es genau ein Element und genau ein Zustand.

     Bei den Mehrfachstufen ist das Panel zugeklappt — der Picker ist dann im
     DOM vorhanden, aber unsichtbar. Das ist gewollt: Das Produktformular
     braucht ihn, die Farbwahl fuer mehrere Taschen laeuft ueber die Staffel. */
  function pickerEinhaengen() {
    var stf = document.querySelector('.eng-stf');
    if (!stf || stf.hasAttribute('data-eng-picker-drin')) return;

    var picker = document.querySelector('variant-selects, variant-picker');
    if (!picker || picker.closest('.eng-stf')) return;

    /* 26.09.2026: Steht oben in der Staffel ein eigener Halter (Parameter
       farbe_oben), geht der Picker dorthin — dauerhaft sichtbar, nicht im
       Klappbereich, und damit zwischen Benefit-Balken und Staffel. Verschoben
       wird er weiterhin und nicht nachgebaut: es bleibt genau EIN Picker und
       genau eine Wahrheit fuer das Produktformular.
       Fehlt der Halter, laeuft alles wie vorher in den Klappbereich der
       Einzelstufe — Vorlagen ohne den Schalter aendern sich nicht. */
    var panel = stf.querySelector('[data-eng-stf-picker-halter]');

    if (!panel) {
      var stufe1 = stf.querySelector('.eng-stf__stufe');
      if (!stufe1) return;
      panel = stufe1.querySelector('.eng-stf__panel');
      if (!panel) return;

      /* Der Verweistext wird ueberfluessig, sobald der Picker hier steht */
      var hinweis = panel.querySelector('.eng-stf__verweis, p');
      if (hinweis && /Variantenauswahl|oben/i.test(hinweis.textContent || '')) {
        hinweis.remove();
      }
    }

    panel.appendChild(picker);
    picker.classList.add('eng-stf__picker');
    stf.setAttribute('data-eng-picker-drin', '');
  }
  document.addEventListener('DOMContentLoaded', pickerEinhaengen);
  setTimeout(pickerEinhaengen, 300);


  /* ── Eine Ueberschrift statt zweier ueber dem Picker ──────────────────────
     Wunsch Werner 04.09.2026. Der Picker bringt je Option eine eigene
     Beschriftung mit ("Wähle deine Schulterseite", "Wähle deine Farbe").
     Untereinander wirkt das doppelt.

     Der Text wird NICHT fest hinterlegt, sondern aus den vorhandenen Optionen
     gebaut: Bei der Curved ergibt das "Wähle deine Schulterseite und Farbe",
     bei TravelFit und SportFit nur "Wähle deine Farbe" — die haben keine
     Schulterseite. Eine feste Zeile waere dort schlicht falsch.             */
  function pickerUeberschrift() {
    var picker = document.querySelector('.eng-stf .eng-stf__picker');
    if (!picker || picker.hasAttribute('data-eng-titel')) return;

    var labels = picker.querySelectorAll('legend, .form__label');
    /* Auch bei EINER Option bauen. Frueher stand hier `< 2` mit der Begruendung
       "eine Option: nichts zu buendeln". Das war zu kurz gedacht: ohne diese
       Ueberschrift setzt die Funktion kein `data-eng-titel`, wahlAnzeige()
       bricht danach ohne Titel ab, und damit faellt auch `data-eng-gewaehlt`
       aus — die vom Kunden gewaehlte Farbe bekommt in Stufe 1 nie einen Ring.
       Am Store gemessen 05.09.2026 an TravelFit und SportFit (je nur die
       Option "Farbe"): nach dem Klick weder Ring noch Schein, und im Kopf
       fehlte "noch offen". Bei einer Option ergibt der Bau schlicht wieder
       "Waehle deine Farbe" — gleicher Wortlaut, aber als ENGORI-Ueberschrift
       mit Wahlanzeige, wie bei der Curved. */
    if (!labels.length) return;

    var teile = [];
    Array.prototype.forEach.call(labels, function (l) {
      /* "Wähle deine Schulterseite" -> "Schulterseite" */
      var t = (l.textContent || '').replace(/\s+/g, ' ').trim();
      t = t.replace(/^(Wähle|Waehle)\s+(deine|deinen|dein)\s+/i, '');
      t = t.replace(/:$/, '').trim();
      if (t && teile.indexOf(t) === -1) teile.push(t);
      l.hidden = true;
    });
    if (!teile.length) return;

    var text = teile.length === 1
      ? teile[0]
      : teile.slice(0, -1).join(', ') + ' und ' + teile[teile.length - 1];

    var h = document.createElement('p');
    h.className = 'eng-stf__picker-titel';
    var ht = document.createElement('span');
    ht.className = 'eng-stf__picker-titel-text';
    /* "Wähle deine Farbe", aber "Wähle Farbstil, Schulterseite und Farbe" —
       "deine Farbstil" war grammatisch falsch (27.09.2026). */
    ht.textContent = (teile.length === 1 ? 'Wähle deine ' : 'Wähle ') + text;
    h.appendChild(ht);
    picker.insertBefore(h, picker.firstChild);
    picker.setAttribute('data-eng-titel', '');
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(pickerUeberschrift, 420); });
  setTimeout(pickerUeberschrift, 700);


  /* ── Erst nach eigener Wahl markieren, und die Wahl im Kopf anzeigen ──────
     Wunsch Werner 04.09.2026: "die ausgewählte tasche soll angezeigt werden
     und vorher ist nichts ausgewählt".

     Shopify waehlt beim Seitenaufbau immer eine Variante vor — das Formular
     braucht eine. Die Vorauswahl bleibt technisch bestehen (sonst liesse sich
     nichts in den Warenkorb legen), wird aber erst optisch markiert, wenn der
     Kunde selbst geklickt hat. Bis dahin steht im Kopf "noch offen", genau
     wie bei den Farbplaetzen der Mehrfachstufen.                            */
  function wahlAnzeige() {
    var picker = document.querySelector('.eng-stf .eng-stf__picker');
    if (!picker || picker.hasAttribute('data-eng-wahl-aktiv')) return;
    var titel = picker.querySelector('.eng-stf__picker-titel');
    if (!titel) return;

    var anzeige = document.createElement('span');
    anzeige.className = 'eng-stf__picker-wahl';
    anzeige.setAttribute('data-offen', '');
    anzeige.textContent = 'noch offen';
    titel.appendChild(anzeige);

    function name() {
      var gewaehlt = picker.querySelector('.color-swatch input:checked');
      if (!gewaehlt) return '';
      /* value ist z. B. "Schwarz - Rechts" — die Schulterseite steht schon
         als eigener Umschalter darueber, hier reicht die Farbe. */
      return (gewaehlt.value || '').split(/\s[-–]\s/)[0].trim();
    }

    /* Die Staffel-Instanz haengt an dieser Meldung: Ohne sie bliebe der
       Kaufknopf nach dem Klick gesperrt, weil syncCta() nichts von der
       getroffenen Wahl erfaehrt. */
    function melde() {
      document.dispatchEvent(new CustomEvent('engori:staffel:wahl'));
    }

    function uebernehmen() {
      picker.setAttribute('data-eng-gewaehlt', '');
      anzeige.removeAttribute('data-offen');
      anzeige.textContent = name() || 'gewählt';
      melde();
    }

    /* Gegenstueck: zurueck auf "noch offen", ohne die Variante anzufassen.
       Gebraucht beim Wechsel auf zwei oder vier Taschen — dort fuehren die
       Farbzeilen der Karten, oben darf nichts als gewaehlt dastehen. */
    function zuruecksetzen() {
      picker.removeAttribute('data-eng-gewaehlt');
      anzeige.setAttribute('data-offen', '');
      anzeige.textContent = 'noch offen';
    }

    /* Der Picker fuehrt in JEDER Stufe (29.09.2026, Werner). Bis dahin war er in
       den Buendelstufen reine Ansicht mit dem Titel „Farben ansehen" und ohne
       Wahlanzeige (27.09., Leon) — beides ist unten ausdruecklich aufgehoben.
       Zurueck auf Stufe 1 gilt die Farbe, die oben gerade gezeigt wird — kein
       Sprung auf die erste Kugel. */
    var titelText = titel.querySelector('.eng-stf__picker-titel-text');
    var titelEinzel = titelText ? titelText.textContent : '';
    function titelSetzen(buendel) {
      /* 29.09.2026 (Werner): „waehle deine farbe“ — die Ueberschrift heisst in
         allen Stufen gleich. „Farben ansehen“ (27.09., Leon) passte, solange
         oben nichts markiert war; seit die Vorauswahl sichtbar ist, stuende
         daneben eine gewaehlte Farbe unter einer Ueberschrift, die das
         Waehlen abspricht. Der Parameter bleibt erhalten, damit sich die
         Unterscheidung mit einer Zeile zurueckholen laesst. */
      if (titelText) titelText.textContent = titelEinzel;
      /* 29.09.2026 (Werner): „kannst du im varianten auswahl den ersten
         vorauswaehlen" — die Wahlanzeige bleibt auch in den Buendelstufen
         sichtbar. Vorher war sie dort verborgen (27.09., Leon), weil der
         Picker im Buendel als reine Ansicht gedacht war. Werner hat das
         ausdruecklich geaendert. */
      anzeige.hidden = false;
    }

    document.addEventListener('engori:staffel:stufe', function (e) {
      var buendel = !e.detail || e.detail.menge !== 1;
      titelSetzen(buendel);
      uebernehmen();
    });

    /* Einmal den Stand abgleichen, statt nur auf kuenftige Wechsel zu hoeren.
       Sonst haengt es am Zufall, ob diese Funktion vor oder nach dem ersten
       Stufenklick laeuft: laeuft sie danach, legt sie die Anzeige neu mit
       "noch offen" an und der Klick auf die Einzelstufe war umsonst — genau
       das war am 26.09.2026 beim ersten Klick zu sehen. Steht das
       Zweierbuendel, bleibt es bei "noch offen". */
    var aktivRadio = document.querySelector('.eng-stf input[data-eng-stf-menge]:checked');
    var startEinzel = aktivRadio && (parseInt(aktivRadio.dataset.engStfMenge, 10) || 1) === 1;
    titelSetzen(!startEinzel);
    /* Auch beim Seitenaufbau markiert, nicht erst nach einem Klick (Werner,
       29.09.2026). Die gezeigte Farbe ist die, die der Picker ohnehin traegt. */
    uebernehmen();

    /* Hier stand `imBuendel()` (27.09., Leon): es hat jeden Picker-Klick in den
       Buendelstufen als reine Bildansicht behandelt. Mit der Vorgabe vom
       29.09.2026 hatte die Funktion keinen Aufrufer mehr und ist entfernt —
       eine Ruine mit genau dem Zweck, der zurueckgenommen wurde, holt der
       naechste Leser sonst wieder hervor. */

    picker.addEventListener('change', function (e) {
      if (!e.target || e.target.type !== 'radio') return;
      /* 29.09.2026 (Werner): „jetzt kann man keine mehr auswaehlen“. Konnte
         man doch — die Variante wechselte korrekt, nur die Anzeige oben blieb
         auf der alten Farbe stehen, weil sie in den Buendelstufen absichtlich
         nicht mitgezogen wurde. Das sah aus wie ein toter Picker. Die Anzeige
         folgt jetzt in JEDER Stufe der Wahl. */
      uebernehmen();
    });

    /* Auch auf den Klick hoeren: Wer die bereits vorausgewaehlte Farbe
       anklickt, loest kein change aus — die Anzeige bliebe sonst auf
       "noch offen" stehen, obwohl der Kunde gewaehlt hat. */
    picker.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.color-swatch')) return;
      setTimeout(uebernehmen, 30);
    });

    picker.setAttribute('data-eng-wahl-aktiv', '');

    /* 26.09.2026 (Werner): "bei der Auswahl oben fuer 1 bitte die Vorauswahl
       wegnehmen, damit nur die 2 ausgewaehlt sind die fuer 2 Taschen".
       Der frueher hier stehende Block (07.09.2026) hat die erste Farbe
       angeklickt UND sie sichtbar als gewaehlt gezeigt. Zusammen mit den
       Farbzeilen von Tasche 1 und Tasche 2 standen damit drei Markierungen
       fuer zwei Taschen auf dem Schirm. Er ist ersatzlos entfallen.
       Eine Variante ist trotzdem gesetzt — das Theme waehlt sie vor —,
       sichtbar "gewaehlt" ist oben aber erst, wenn der Kunde dort klickt. */

    melde();
  }
  document.addEventListener('DOMContentLoaded', function () { setTimeout(wahlAnzeige, 500); });
  setTimeout(wahlAnzeige, 800);


  /* ── Farbname unter jeder Swatch-Reihe der Staffel (12.09.2026) ───────────
     Stand nach den Vorgaben Werners vom 12.09.2026:
     - Der Name der GEWAEHLTEN Farbe steht dauerhaft mittig unter ihrem Kreis
       und bleibt dort, auch waehrend ein anderer Kreis beruehrt wird.
     - Maus ueber (oder Tastaturfokus auf) einem ANDEREN Kreis: dessen Name
       erscheint ZUSAETZLICH mittig darunter und verschwindet beim Verlassen
       (90 ms Verzug, sonst blitzt es in den 9 px Luecken zwischen Kreisen).
       Ueber dem gewaehlten Kreis selbst gibt es nur den einen Namen.
     - Kommen sich beide Namen naeher als FARB_LUECKE, wird der gewaehlte Name
       ausgeblendet, solange der Hover-Name steht. Seitlich versetzen wuerde in
       dichten Reihen den naechsten Kreis treffen; Ausblenden ist eindeutig und
       springt nicht.
     - Namen werden an die Inhaltskanten der Reihe geklemmt, nie abgeschnitten.
       Liegt ein Kreis in einer oberen Zeile einer umbrochenen Reihe, steht der
       Name in deren Zeilenabstand.

     Rein darstellend: Nichts hier waehlt, klickt oder aendert einen Zustand.
     Varianten-Picker, Warenkorb, Wallet-Knoepfe und Stufenlogik bleiben
     unberuehrt. Namen kommen aus dem vorhandenen Markup — beim Picker aus dem
     Optionswert ("Schwarz - Rechts" -> "Schwarz", dieselbe Regel wie in
     wahlAnzeige), bei den Farbplaetzen aus dem versteckten Namen der Kachel.

     Aufbau: Der Absatz .eng-stf__farbname ist nur Platzhalter fester Hoehe im
     Fluss. Darin zwei absolut positionierte Namen (data-eng-farbname="wahl"
     und "hover"), bezogen auf das Elternteil der Reihe (slot-body bzw. die
     Swatch-Gruppe des Pickers, beide position: relative).

     Zugaenglichkeit: Die Zeile ist aria-hidden, sie wiederholt nur, was die
     Kacheln selbst ansagen. Die Radios des Theme-Pickers hatten KEINEN Namen
     (leeres label, gemessen 12.09.2026) und bekommen ein aria-label aus ihrem
     Wert, falls keines da ist. Keine aria-live-Region.

     Touch: Hover nur fuer echte Mauszeiger auf Geraeten mit (hover: hover);
     Fokus zeigt einen Namen nur bei :focus-visible (Tastatur).

     Die Farbplaetze werden bei jeder Wahl neu aufgebaut, der Picker kann vom
     Theme neu gerendert werden. Ein MutationObserver baut die Zeilen idempotent
     nach — direkt im Callback, NICHT ueber requestAnimationFrame: rAF pausiert
     in Hintergrund-Tabs, dann blieben spaet aufgebaute Farbplaetze ohne Zeile
     (gemessen 12.09.2026). */
  var FARB_REIHEN = '.eng-stf .eng-bdl__grid, .eng-stf__picker .color-swatches-container';
  var farbHoverGeraet = window.matchMedia ? window.matchMedia('(hover: hover)') : null;
  var FARB_LUECKE = 6;

  function farbReiheVon(el) {
    return el && el.closest ? el.closest(FARB_REIHEN) : null;
  }

  function farbKachelVon(el) {
    if (!el || !el.closest) return null;
    var k = el.closest('.eng-bdl__tile, .color-swatch');
    return k && farbReiheVon(k) ? k : null;
  }

  function farbNameVon(kachel) {
    if (!kachel) return '';
    if (kachel.classList.contains('eng-bdl__tile')) {
      var s = kachel.querySelector('span');
      return s ? s.textContent.trim() : '';
    }
    var inp = kachel.matches('input') ? kachel : kachel.querySelector('input[type="radio"]');
    return inp ? (inp.value || '').split(/\s[-–]\s/)[0].trim() : '';
  }

  function farbGewaehlteKachel(reihe) {
    var t = reihe.querySelector('.eng-bdl__tile[aria-pressed="true"]');
    if (t) return t;
    var i = reihe.querySelector('.color-swatch input[type="radio"]:checked');
    return i ? i.closest('.color-swatch') : null;
  }

  function farbZeileVon(reihe) {
    var z = reihe.nextElementSibling;
    return z && z.classList.contains('eng-stf__farbname') ? z : null;
  }

  function farbSpans(reihe) {
    var z = farbZeileVon(reihe);
    if (!z) return null;
    var w = z.querySelector('[data-eng-farbname="wahl"]');
    var h = z.querySelector('[data-eng-farbname="hover"]');
    return w && h ? { wahl: w, hover: h } : null;
  }

  function farbTastatur(el) {
    try { return !!el && el.matches(':focus-visible'); } catch (err) { return false; }
  }

  /* Versatz durch transform (die Kachel hebt sich beim Hover um 4 px). Ohne
     Abzug wuerde der Name beim Beruehren mit dem Kreis nach oben wandern. */
  function farbVersatz(el) {
    var x = 0, y = 0, gesehen = [];
    [el, el.closest('.eng-bdl__tile, .color-swatch')].forEach(function (e) {
      if (!e || gesehen.indexOf(e) !== -1) return;
      gesehen.push(e);
      var t = getComputedStyle(e).transform;
      if (t && t !== 'none' && window.DOMMatrixReadOnly) {
        var m = new DOMMatrixReadOnly(t);
        x += m.m41;
        y += m.m42;
      }
    });
    return { x: x, y: y };
  }

  /* Schiebt einen Namen mittig unter den Kreis, geklemmt an die Reihe.
     Liefert die Zielkanten (nicht die gerade animierte Lage) oder null. */
  function farbSetze(reihe, span, kachel, gleiten) {
    var bezug = span.offsetParent;
    if (!kachel || !kachel.isConnected || !bezug || !reihe.getClientRects().length) return null;

    var kreis = kachel.classList.contains('eng-bdl__tile')
      ? kachel
      : (kachel.querySelector('.color-swatch__image') || kachel);
    var v = farbVersatz(kreis);
    var kr = kreis.getBoundingClientRect();
    var br = bezug.getBoundingClientRect();
    var rr = reihe.getBoundingClientRect();
    var cs = getComputedStyle(reihe);

    var lo = Math.max(rr.left + (parseFloat(cs.paddingLeft) || 0), br.left) - br.left;
    var hi = Math.min(rr.right - (parseFloat(cs.paddingRight) || 0), br.right) - br.left;
    span.style.maxWidth = Math.max(0, hi - lo) + 'px';

    var w = span.offsetWidth;
    var mitte = kr.left + kr.width / 2 - v.x - br.left;
    var x = Math.round(Math.min(Math.max(mitte - w / 2, lo), Math.max(lo, hi - w)));
    /* +1 px: Bei umbrochenen Reihen liegen 20 px zwischen den Kreisreihen,
       die Zeile ist 18 px hoch. Mit +2 beruehrte sie die naechste Reihe
       (gemessen 12.09.2026, 375 px: -1 px). */
    var y = Math.round(kr.bottom - v.y - br.top + 1);

    var springen = !gleiten || !span.dataset.engPos;
    if (springen) span.style.transition = 'none';
    span.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    if (springen) {
      void span.offsetWidth;
      span.style.transition = '';
    }
    span.dataset.engPos = '1';
    return { links: x, rechts: x + w };
  }

  function farbAktualisieren(reihe) {
    if (!reihe || !reihe.isConnected) return;
    var s = farbSpans(reihe);
    if (!s) return;

    var wahl = farbGewaehlteKachel(reihe);
    var wahlName = wahl ? farbNameVon(wahl) : '';
    if (s.wahl.textContent !== wahlName) s.wahl.textContent = wahlName;
    reihe._engFarbWahl = wahl;
    var kw = farbSetze(reihe, s.wahl, wahl, true);

    var hk = reihe._engFarbHover;
    if (hk && (!hk.isConnected || farbReiheVon(hk) !== reihe)) hk = reihe._engFarbHover = null;
    if (!hk || hk === wahl) {
      s.hover.classList.remove('is-an');
      s.wahl.classList.remove('is-verdeckt');
      return;
    }

    var hn = farbNameVon(hk);
    if (s.hover.textContent !== hn) s.hover.textContent = hn;
    var war = s.hover.classList.contains('is-an');
    var kh = farbSetze(reihe, s.hover, hk, war);
    s.hover.classList.add('is-an');

    var zuDicht = !!(kw && kh &&
      kh.links < kw.rechts + FARB_LUECKE &&
      kh.rechts > kw.links - FARB_LUECKE);
    s.wahl.classList.toggle('is-verdeckt', zuDicht);
  }

  function farbHover(kachel) {
    var reihe = farbReiheVon(kachel);
    if (!reihe) return;
    clearTimeout(reihe._engFarbTimer);
    reihe._engFarbHover = kachel;
    farbAktualisieren(reihe);
  }

  function farbHoverEnde(reihe) {
    if (!reihe || !reihe.isConnected) return;
    var fokus = farbKachelVon(document.activeElement);
    reihe._engFarbHover =
      fokus && farbReiheVon(fokus) === reihe && farbTastatur(document.activeElement) ? fokus : null;
    farbAktualisieren(reihe);
  }

  /* Gedrosselt nachlaufend (50 ms): Beim Ziehen am Fensterrand feuern Resize
     und ResizeObserver dutzendfach, gemessen wird erst, wenn es ruhig ist.
     setTimeout statt requestAnimationFrame — rAF pausiert in verdeckten Tabs. */
  function farbSpaeter(reihe) {
    clearTimeout(reihe._engFarbDrossel);
    reihe._engFarbDrossel = setTimeout(function () { farbAktualisieren(reihe); }, 50);
  }

  function farbBeobachten(reihe) {
    if (reihe._engFarbBeobachtet) return;
    reihe._engFarbBeobachtet = true;
    /* Die Reihe bricht seit 12.09.2026 in allen Breiten um: Aendert sich ihre
       Breite, wandern Kreise in andere Zeilen — dann neu positionieren. */
    if (window.ResizeObserver) {
      new ResizeObserver(function () { farbSpaeter(reihe); }).observe(reihe);
    }
    reihe.addEventListener('scroll', function () { farbSpaeter(reihe); }, { passive: true });
  }

  function farbnamenAufbauen() {
    Array.prototype.forEach.call(document.querySelectorAll(FARB_REIHEN), function (reihe) {
      var z = farbZeileVon(reihe);
      if (!z && reihe.parentNode) {
        z = document.createElement('p');
        z.className = 'eng-stf__farbname';
        z.setAttribute('aria-hidden', 'true');
        reihe.parentNode.insertBefore(z, reihe.nextSibling);
      }
      if (!z) return;
      if (!farbSpans(reihe)) {
        z.textContent = '';
        ['wahl', 'hover'].forEach(function (rolle) {
          var sp = document.createElement('span');
          sp.className = 'eng-stf__farbname-text' + (rolle === 'hover' ? ' eng-stf__farbname-text--hover' : '');
          sp.setAttribute('data-eng-farbname', rolle);
          z.appendChild(sp);
        });
      }
      farbBeobachten(reihe);

      Array.prototype.forEach.call(reihe.querySelectorAll('.color-swatch input[type="radio"]'), function (inp) {
        var label = inp.labels && inp.labels[0] ? inp.labels[0].textContent.trim() : '';
        if (!inp.getAttribute('aria-label') && !inp.getAttribute('aria-labelledby') && !label && inp.value) {
          inp.setAttribute('aria-label', inp.value);
        }
      });

      /* Nur bei Aenderung neu setzen: der Observer laeuft bei jeder
         DOM-Aenderung in der Staffel (seit 25.09.2026 gefiltert, vorher die
         ganze Seite), Messen kostet Layout. */
      var s = farbSpans(reihe);
      if (farbGewaehlteKachel(reihe) !== reihe._engFarbWahl || !s.wahl.dataset.engPos) {
        farbAktualisieren(reihe);
      }
    });
  }

  document.addEventListener('pointerover', function (e) {
    if (e.pointerType !== 'mouse' || (farbHoverGeraet && !farbHoverGeraet.matches)) return;
    var k = farbKachelVon(e.target);
    if (k) farbHover(k);
  });

  document.addEventListener('pointerout', function (e) {
    if (e.pointerType !== 'mouse') return;
    var k = farbKachelVon(e.target);
    if (!k || (e.relatedTarget && k.contains(e.relatedTarget))) return;
    var reihe = farbReiheVon(k);
    clearTimeout(reihe._engFarbTimer);
    reihe._engFarbTimer = setTimeout(function () { farbHoverEnde(reihe); }, 90);
  });

  document.addEventListener('focusin', function (e) {
    var k = farbKachelVon(e.target);
    if (k && farbTastatur(e.target)) farbHover(k);
  });

  document.addEventListener('focusout', function (e) {
    var k = farbKachelVon(e.target);
    if (!k) return;
    var reihe = farbReiheVon(k);
    setTimeout(function () { farbHoverEnde(reihe); }, 0);
  });

  /* Wahl im Theme-Picker (Klick, Tippen, Pfeiltasten). Die Farbplaetze bauen
     sich selbst neu auf und laufen ueber den Observer. */
  document.addEventListener('change', function (e) {
    var reihe = farbReiheVon(e.target);
    if (reihe) farbAktualisieren(reihe);
  });

  window.addEventListener('resize', function () {
    Array.prototype.forEach.call(document.querySelectorAll(FARB_REIHEN), farbSpaeter);
  });

  new MutationObserver(function (liste) { if (inStaffel(liste)) farbnamenAufbauen(); })
    .observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', farbnamenAufbauen);
  setTimeout(farbnamenAufbauen, 900);

})();
